const repeatServicesTimeUnits = [
  { value: 1, label: 'days' },
  { value: 2, label: 'weeks' },
  { value: 3, label: 'months' },
];

const creationTypes = {
  ASSIGNED: {
    value: 1,
    label: 'operator',
  },
  SELF_SCHEDULED: {
    value: 2,
    label: 'finalCustomer',
  },
};

const alertTypes = {
  WITHOUT_ALERT: { id: 0, label: 'withoutAlert' },
  PENDING: { id: 1, label: 'pendingAlert' },
  FINISHED: { id: 2, label: 'finishedAlert' },
};

const incidentDetailTabs = {
  service: { title: 'service' },
  finalCustomer: { title: 'finalCustomer' },
  summary: { title: 'summary' },
  review: { title: 'review' },
  chat: { title: 'chat', fullWidth: true },
  notes: { title: 'notes' },
  surveys: { title: 'surveys' },
};

const exportTypes = {
  XLSX: { value: 'xlsx', label: 'Excel' },
  PDF_ZIP: { value: 'zip', label: 'PDF - Zip' },
};

export { repeatServicesTimeUnits, creationTypes, alertTypes, incidentDetailTabs, exportTypes };
